import React, { useEffect, useState } from "react";
import searchIcon from "assets/images/icons/search2.svg";

const SearchPaymentMethod = ({ paymentMethod, setFilteredPayment }) => {
  const [value, setValue] = useState(null);
  const combinedData = [].concat(...Object.values(paymentMethod));

  useEffect(() => {
    let timer;
    const debounceFn = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const filteredData = combinedData.filter((item) =>
          item.label.toLowerCase().includes(value?.toLowerCase())
        );
        setFilteredPayment(value ? filteredData : null);
      });
    };
    debounceFn();
    return () => {
      clearTimeout(timer);
    };
  }, [value, combinedData, setFilteredPayment]);

  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <div className="search-container mt-lg-5 mt-0">
          <label htmlFor="searchPayment" className="fw-bold">
            Cari Metode Pembayaran
          </label>
          <div className="position-relative">
            <input
              type="text"
              className="form-control border-1 my-3 rounded-4 py-2 pe-5"
              name="searchPayment"
              id="searchPayment"
              onChange={(e) => setValue(e.target.value)}
              placeholder="Cari..."
            />
            <img
              src={searchIcon}
              alt="searchIcon.svg"
              width="28px"
              height="28px"
              className="icon-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchPaymentMethod;
